module.exports = __webpack_public_path__ + "img/05.1bf75481.jpg";